export enum CUSTOMER_TIER {
    TIER_1 = "tier 1",
    TIER_2 = "tier 2",
    TIER_3 = "tier 3",
}

export enum URGENCY {
    URGENT = "Gấp",
    NON_URGENT = "Không Gấp",
}

export enum ROLE {
    MANAGER = "MANAGER", // Quản lý 
    SALE_STAFF = "SALE_STAFF", // Nhân viên bán hàng
    SALE_MANAGER = "SALE_MANAGER",
    LOGISTIC_MANAGER = "LOGISTIC_MANAGER", // Quản lý hậu cần
    LOGISTIC_STAFF = "LOGISTIC_STAFF",
    STORAGE_KEEPER = "STORAGE_KEEPER", // Thủ kho
    DELIVERER = "DELIVERER",
    FIRST_STORAGE_KEEPER = "FIRST_STORAGE_KEEPER", // Thủ kho 1
    SECOND_STORAGE_KEEPER = "SECOND_STORAGE_KEEPER", // Thủ kho 2
    PURCHASING_STAFF = "PURCHASING_STAFF", // Nhân viên hậu cần mua vật tư
    PRODUCTION_STAFF = "PRODUCTION_STAFF", // Nhân viên hậu cần điều phối
    ACCOUNTANT_MANAGER = "ACCOUNTANT_MANAGER", // Quản lý kế toán
    FACTORY_STAFF = "FACTORY_STAFF", // Nhân viên xưởng
    FACTORY_MANAGER_ONE = "FACTORY_MANAGER_ONE", // Quản lý xưởng phuy thùng
    FACTORY_MANAGER_TWO = "FACTORY_MANAGER_TWO", // Quản lý xưởng cơ khí ô tô
    DEPUTY_FACTORY_MANAGER_ONE = "DEPUTY_FACTORY_MANAGER_ONE", // Phó quản lý xưởng phuy thùng
    DEPUTY_FACTORY_MANAGER_TWO = "DEPUTY_FACTORY_MANAGER_TWO", // Phó quản lý xưởng cơ khí ô tô
}

export enum STORAGE {
    FIRST = "Kho 1",
    SECOND = "Kho 2",
}

export enum MATERIAL_CATEGORY {
    MAIN = "Vật tư chính",
    SECONDARY = "Vật tư phụ",
    OTHER = "Vật tư khác",
}

export enum PRODUCT_CATEGORY {
    BARREL = "Phuy",
    VESSEL = "Thùng",
    VEHICLE = "Cơ Khí Ô Tô",
}

export enum PRODUCT_STATUS {
    ACTIVE = "Hoạt động",
    INACTIVE = "Vô hiệu hoá",
}

export enum PRODUCT_ORDER_URGENCY {
    URGENT = "Gấp",
    NON_URGENT = "Không Gấp",
}

export enum PRODUCT_ORDER_STATUS {
    OPEN = "Open",
    PROCESSING = "Processing",
    BUYING_MATERIAL = "BuyingMaterial",
    ASSIGNING_STORAGE_KEEPER = "AssigningStorageKeeper",
    IN_PRODUCTION = "InProduction",
    IMPORTING_TO_STORAGE = "ImportingToStorage",
    PENDING = "Pending",
    DECLINED = "Declined",
    DELIVERING = "Delivering",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
}

export enum MATERIAL_ORDER_URGENCY {
    URGENT = "Gấp",
    NON_URGENT = "Không Gấp",
}

export enum MATERIAL_ORDER_STATUS {
    OPEN = "Open",
    PENDING = "Pending",
    IMPORTING = "Importing",
    RESTOCK = "Restock",
    RESTOCK_PENDING = "ImportPending",
    CANCELLED = "Cancelled",
}

export enum MATERIAL_REQUEST_STATUS {
    OPEN = "Open",
    EXPORTING = "Exporting",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
}

export enum OUTSOURCE_ORDER_STATUS {
    OPEN = "Open",
    EXPORTING = "Exporting",
    PARTIALLY_RETURNED = "PartiallyReturned",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
}

export enum OUTSOURCE_ORDER_URGENCY {
    URGENT = "Gấp",
    NON_URGENT = "Không Gấp",
}

export enum KPI_STATUS {
    OPEN = "Open",
    ONGOING = "Ongoing",
    ACHIEVED = "Achieved",
    FAILED = "Failed",
}

export enum KPI_TEXT {
    REMAINING = "Số lượng còn thiếu",
    CURRENT = "Số lượng hiện tại",
}

export const DURATION_UNIT = {
    YEAR: "Năm",
    MONTH: "Tháng",
};

export enum SALE_ORDER_STATUS {
    OPEN = "OPEN",
    LOGISTIC_REVIEWED = "LOGISTIC_REVIEWED",
    MATERIAL_REQUESTED_AND_MANUFACTURING = "MATERIAL_REQUESTED_AND_MANUFACTURING",
    IMPORTING_AND_EXPORTING = "IMPORTING_AND_EXPORTING",
    COMPLETED = "COMPLETED",
    CANCELLED = "CANCELLED",
}

export enum SALE_ORDER_TYPE {
    SALE = "SALE",
    RESERVE = "RESERVE",
}

export enum WORKSHOP {
    BARREL_VESSEL = "BARREL_VESSEL",
    AUTOMOTIVE = "AUTOMOTIVE",
}

export enum DELIVERY_TRIP_STATUS {
    PENDING = "PENDING",
    SCHEDULED = "SCHEDULED",
    IN_TRANSIT = "IN_TRANSIT",
    DELIVERED = "DELIVERED",
    RETURNED = "RETURNED",
    CANCELLED = "CANCELLED",
}
